var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10,10)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.442,24.378C41.748,24.378 41.185,23.815 41.185,23.121L41.185,18.2C41.185,17.506 41.748,16.943 42.442,16.943C43.136,16.943 43.7,17.506 43.7,18.2L43.7,23.121C43.7,23.815 43.136,24.378 42.442,24.378Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.392,24.378C46.697,24.378 46.134,23.815 46.134,23.121L46.134,18.2C46.134,17.506 46.697,16.943 47.392,16.943C48.086,16.943 48.649,17.506 48.649,18.2L48.649,23.121C48.649,23.815 48.086,24.378 47.392,24.378Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.54,33.983C31.846,33.983 31.283,33.42 31.283,32.725L31.283,27.804C31.283,27.11 31.846,26.547 32.54,26.547C33.235,26.547 33.798,27.11 33.798,27.804L33.798,32.725C33.798,33.42 33.235,33.983 32.54,33.983Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.49,33.983C36.795,33.983 36.232,33.42 36.232,32.725L36.232,27.804C36.232,27.11 36.795,26.547 37.49,26.547C38.184,26.547 38.747,27.11 38.747,27.804L38.747,32.725C38.747,33.42 38.184,33.983 37.49,33.983Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.442,33.983C41.748,33.983 41.185,33.42 41.185,32.725L41.185,27.804C41.185,27.11 41.748,26.547 42.442,26.547C43.136,26.547 43.7,27.11 43.7,27.804L43.7,32.725C43.7,33.42 43.136,33.983 42.442,33.983Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.392,33.983C46.697,33.983 46.134,33.42 46.134,32.725L46.134,27.804C46.134,27.11 46.697,26.547 47.392,26.547C48.086,26.547 48.649,27.11 48.649,27.804L48.649,32.725C48.649,33.42 48.086,33.983 47.392,33.983Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.588,43.594C26.894,43.594 26.331,43.031 26.331,42.337L26.331,37.416C26.331,36.722 26.894,36.159 27.588,36.159C28.282,36.159 28.845,36.722 28.845,37.416L28.845,42.337C28.845,43.031 28.282,43.594 27.588,43.594Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.54,43.594C31.846,43.594 31.283,43.031 31.283,42.337L31.283,37.416C31.283,36.722 31.846,36.159 32.54,36.159C33.235,36.159 33.798,36.722 33.798,37.416L33.798,42.337C33.798,43.031 33.235,43.594 32.54,43.594Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.49,43.594C36.795,43.594 36.232,43.031 36.232,42.337L36.232,37.416C36.232,36.722 36.795,36.159 37.49,36.159C38.184,36.159 38.747,36.722 38.747,37.416L38.747,42.337C38.747,43.031 38.184,43.594 37.49,43.594Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.442,43.594C41.748,43.594 41.185,43.031 41.185,42.337L41.185,37.416C41.185,36.722 41.748,36.159 42.442,36.159C43.136,36.159 43.7,36.722 43.7,37.416L43.7,42.337C43.7,43.031 43.136,43.594 42.442,43.594Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.392,43.594C46.697,43.594 46.134,43.031 46.134,42.337L46.134,37.416C46.134,36.722 46.697,36.159 47.392,36.159C48.086,36.159 48.649,36.722 48.649,37.416L48.649,42.337C48.649,43.031 48.086,43.594 47.392,43.594Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.54,53.199C31.846,53.199 31.283,52.636 31.283,51.941L31.283,47.02C31.283,46.326 31.846,45.763 32.54,45.763C33.235,45.763 33.798,46.326 33.798,47.02L33.798,51.941C33.798,52.636 33.235,53.199 32.54,53.199Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.49,53.199C36.795,53.199 36.232,52.636 36.232,51.941L36.232,47.02C36.232,46.326 36.795,45.763 37.49,45.763C38.184,45.763 38.747,46.326 38.747,47.02L38.747,51.941C38.747,52.636 38.184,53.199 37.49,53.199Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.442,53.199C41.748,53.199 41.185,52.636 41.185,51.941L41.185,47.02C41.185,46.326 41.748,45.763 42.442,45.763C43.136,45.763 43.7,46.326 43.7,47.02L43.7,51.941C43.7,52.636 43.136,53.199 42.442,53.199Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.392,53.199C46.697,53.199 46.134,52.636 46.134,51.941L46.134,47.02C46.134,46.326 46.697,45.763 47.392,45.763C48.086,45.763 48.649,46.326 48.649,47.02L48.649,51.941C48.649,52.636 48.086,53.199 47.392,53.199Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.442,62.81C41.748,62.81 41.185,62.247 41.185,61.553L41.185,56.632C41.185,55.937 41.748,55.374 42.442,55.374C43.136,55.374 43.7,55.937 43.7,56.632L43.7,61.553C43.7,62.247 43.136,62.81 42.442,62.81Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.293,55.374C57.987,55.374 58.551,55.937 58.551,56.632L58.551,61.553C58.551,62.247 57.987,62.81 57.293,62.81C56.599,62.81 56.036,62.247 56.036,61.553L56.036,56.632C56.036,55.937 56.599,55.374 57.293,55.374Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.199,45.763C67.893,45.763 68.456,46.326 68.456,47.02L68.456,51.941C68.456,52.636 67.893,53.199 67.199,53.199C66.504,53.199 65.941,52.636 65.941,51.941L65.941,47.02C65.941,46.326 66.504,45.763 67.199,45.763Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.246,45.763C62.94,45.763 63.503,46.326 63.503,47.02L63.503,51.941C63.503,52.636 62.94,53.199 62.246,53.199C61.552,53.199 60.989,52.636 60.989,51.941L60.989,47.02C60.989,46.326 61.552,45.763 62.246,45.763Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.293,45.763C57.987,45.763 58.551,46.326 58.551,47.02L58.551,51.941C58.551,52.636 57.987,53.199 57.293,53.199C56.599,53.199 56.036,52.636 56.036,51.941L56.036,47.02C56.036,46.326 56.599,45.763 57.293,45.763Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.148,36.159C72.842,36.159 73.405,36.722 73.405,37.416L73.405,42.337C73.405,43.031 72.842,43.594 72.148,43.594C71.454,43.594 70.891,43.031 70.891,42.337L70.891,37.416C70.891,36.722 71.454,36.159 72.148,36.159Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.199,36.159C67.893,36.159 68.456,36.722 68.456,37.416L68.456,42.337C68.456,43.031 67.893,43.594 67.199,43.594C66.504,43.594 65.941,43.031 65.941,42.337L65.941,37.416C65.941,36.722 66.504,36.159 67.199,36.159Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.246,36.159C62.94,36.159 63.503,36.722 63.503,37.416L63.503,42.337C63.503,43.031 62.94,43.594 62.246,43.594C61.552,43.594 60.989,43.031 60.989,42.337L60.989,37.416C60.989,36.722 61.552,36.159 62.246,36.159Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.293,36.159C57.987,36.159 58.551,36.722 58.551,37.416L58.551,42.337C58.551,43.031 57.987,43.594 57.293,43.594C56.599,43.594 56.036,43.031 56.036,42.337L56.036,37.416C56.036,36.722 56.599,36.159 57.293,36.159Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.199,26.547C67.893,26.547 68.456,27.11 68.456,27.804L68.456,32.725C68.456,33.42 67.893,33.983 67.199,33.983C66.504,33.983 65.941,33.42 65.941,32.725L65.941,27.804C65.941,27.11 66.504,26.547 67.199,26.547Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.246,26.547C62.94,26.547 63.503,27.11 63.503,27.804L63.503,32.725C63.503,33.42 62.94,33.983 62.246,33.983C61.552,33.983 60.989,33.42 60.989,32.725L60.989,27.804C60.989,27.11 61.552,26.547 62.246,26.547Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.293,26.547C57.987,26.547 58.551,27.11 58.551,27.804L58.551,32.725C58.551,33.42 57.987,33.983 57.293,33.983C56.599,33.983 56.036,33.42 56.036,32.725L56.036,27.804C56.036,27.11 56.599,26.547 57.293,26.547Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.293,16.943C57.987,16.943 58.551,17.506 58.551,18.2L58.551,23.121C58.551,23.815 57.987,24.378 57.293,24.378C56.599,24.378 56.036,23.815 56.036,23.121L56.036,18.2C56.036,17.506 56.599,16.943 57.293,16.943Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.392,62.81C46.697,62.81 46.134,62.247 46.134,61.553L46.134,56.632C46.134,55.937 46.697,55.374 47.392,55.374C48.086,55.374 48.649,55.937 48.649,56.632L48.649,61.553C48.649,62.247 48.086,62.81 47.392,62.81Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.344,24.378C51.65,24.378 51.087,23.815 51.087,23.121L51.087,18.2C51.087,17.506 51.65,16.943 52.344,16.943C53.038,16.943 53.601,17.506 53.601,18.2L53.601,23.121C53.601,23.815 53.038,24.378 52.344,24.378Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.344,33.983C51.65,33.983 51.087,33.42 51.087,32.725L51.087,27.804C51.087,27.11 51.65,26.547 52.344,26.547C53.038,26.547 53.601,27.11 53.601,27.804L53.601,32.725C53.601,33.42 53.038,33.983 52.344,33.983Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.344,43.594C51.65,43.594 51.087,43.031 51.087,42.337L51.087,37.416C51.087,36.722 51.65,36.159 52.344,36.159C53.038,36.159 53.601,36.722 53.601,37.416L53.601,42.337C53.601,43.031 53.038,43.594 52.344,43.594Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.344,53.199C51.65,53.199 51.087,52.636 51.087,51.941L51.087,47.02C51.087,46.326 51.65,45.763 52.344,45.763C53.038,45.763 53.601,46.326 53.601,47.02L53.601,51.941C53.601,52.636 53.038,53.199 52.344,53.199Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.344,62.81C51.65,62.81 51.087,62.247 51.087,61.553L51.087,56.632C51.087,55.937 51.65,55.374 52.344,55.374C53.038,55.374 53.601,55.937 53.601,56.632L53.601,61.553C53.601,62.247 53.038,62.81 52.344,62.81Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5,40C89.5,18.199 71.801,0.5 50,0.5C28.199,0.5 10.5,18.199 10.5,40C10.5,61.801 28.199,79.5 50,79.5C71.801,79.5 89.5,61.801 89.5,40Z",
    style: {
      fill: "none",
      stroke: "rgb(232,237,240)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeMiterlimit: 4
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoria);
export default __webpack_public_path__ + "static/media/historia.ad506270.svg";
export { ForwardRef as ReactComponent };